import "./style.css";
import app1 from "Assets/Images/Download/app1.png";
import app2 from "Assets/Images/Download/app2.png";
import icon1 from "Assets/Images/Download/iconapp1.png";
import icon2 from "Assets/Images/Download/iconapp2.png";
import { Link } from "react-router-dom";

const MainDownload = () => {
  return (
    <section className="container py-3 px-0">
      <div className="main-download-boxes d-flex justify-content-between align-items-center">
        {/* 1 */}
        <div className="download-box-each  d-flex justify-content-between align-items-center p-3 bg-shiri">
          <img src={app1} alt="" className="w-50 " />
          <div className="detail-download-app w-50 pe-3 ">
            <div className="title-down-app  d-flex align-items-center mb-3">
              <img src={icon1} alt="" className="ms-2" />
              <h5 className="h-title-download  m-0">
                اَپلیکیشن داپ اَپ (ویژه مشتریان)
              </h5>
            </div>
            <p className="res-down-text text-justify">
              شرکت دانش بنیان درنیکا اندیشه پرهام در تیرماه سال ۱۳۹۸ تأسیس شده و
              برای نخستین بار در ایران، پلتفرم پاداش نقدی خرید با نام تجاری
              “داپ‌اَپ” را با مشارکت نظام بانکی کشور طراحی و راه ‏اندازی کرده
              است
            </p>
            <a
              href="https://landing.daapapp.com/7/"
              className="link-down-app all-butten-site bg-dap-success text-white rounded-pill "
            >
              دانلود اَپلیکیشن داپ اَپ
            </a>
          </div>
        </div>
        {/* 2 */}
        <div className="download-box-each d-flex justify-content-between align-items-center p-3 bg-shiri">
          <img src={app2} alt="" className="w-50 " />
          <div className="detail-download-app w-50 pe-3  ">
            <div className="title-down-app  d-flex align-items-center mb-3">
              <img src={icon2} alt="" className="ms-2" />
              <h5 className="h-title-download  m-0 ">
                اَپلیکیشن داپ اَپ (ویژه پذیرندگان){" "}
              </h5>
            </div>
            <p className="res-down-text text-justify ">
              به منظور استفاده از خدمات داپ اَپ برای پذیرندگان، اپلیکیشن داپ اَپ
              ویژه پذیرندگان را دانلود کنید.
            </p>
            <Link
              to="/dl-merchant-app"
              className=" link-down-app all-butten-site bg-dap-app-blue text-white rounded-pill"
            >
              دانلود اپلیکیشن داپ‌‌اَپ
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainDownload;
